module.exports = __webpack_public_path__ + "img/tap@3x.ce1f2a1b.png";